import { render, staticRenderFns } from "./CreditScoreStep.vue?vue&type=template&id=72135519&"
import script from "./CreditScoreStep.vue?vue&type=script&lang=js&"
export * from "./CreditScoreStep.vue?vue&type=script&lang=js&"
import style0 from "./CreditScoreStep.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports